export class Customer
{
	id: number;
	parent_id: number;
	organisation_id: number;
	status: string;
	name: string;
	street: string;
	house_number: number;
	postal_code: string;
	city: string;
	phone_number: number;
	email: string;
	website: string;
	country_code: string;
	debit_number: string;
	vat_number: string;
	coc_number: number;
	bank_number: string;
	active: string;
}



// WEBPACK FOOTER //
// ./src/app/models/customer.ts